<div class="app-card-box d-flex ion-align-items-center w-100">
    <div class="d-flex ion-align-items-center">
        <div *ngIf="!imageUrl">
            <ng-content select="[image]" #imgTemplate></ng-content>
        </div>
        <div *ngIf="imageUrl"
             class="img-bg"
             [ngClass]="size"
             [class.contain]="contain"
             [appBackgroundImage]="imageUrl"></div>
    </div>
    <div class="ml-sm w-100">
        <div class="d-flex ion-justify-content-between">
            <div class="ts-body-bold">{{ title }}</div>
            <span *ngIf="showArrow"
                  style="font-size: 16px;"
                  class="material-symbols-outlined">arrow_forward_ios</span>
        </div>
        <div class="ts-caption">{{ subTitle }}</div>
        <ng-content select="[section]" #subSectionTemplate></ng-content>
    </div>
</div>
